import { render, staticRenderFns } from "./PageClubInvoiceTransfers.vue?vue&type=template&id=4aa9433e&scoped=true&"
import script from "./PageClubInvoiceTransfers.vue?vue&type=script&lang=js&"
export * from "./PageClubInvoiceTransfers.vue?vue&type=script&lang=js&"
import style0 from "./PageClubInvoiceTransfers.vue?vue&type=style&index=0&id=4aa9433e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa9433e",
  null
  
)

export default component.exports